<template>
    <div v-if="mainElement">

<!-- PARAMETROS TRAMOS DIFERENTES -->
        <editParameterValueComponent
            v-if="helper.isTramosDistintos()"
            ref="editParameterValueComponent"
            :parameter="mainElement['metros_por_tramo']"
            :value.sync="mainElement['metros_por_tramo'].value"
            :placeholder_titel="
                mainElement['metros_por_tramo'].attribute.name
            "
            :style_edit_param="
                'margin-top: ' +
                margin_dropdowns +
                'px ;margin-bottom: ' +
                margin_dropdowns +
                'px;'
            "
            :style_inside_dropdown="
                'padding:4px !important; width: ' + width_params
            "
            :labelOverInput="true"
            :prop_title_show="true"
            @update:value="refreshParameters"
            @beforeUpdate:value="beforeUpdate"
            @afterUpdate:value="afterUpdate"
        ></editParameterValueComponent>
        <editParameterValueComponent
            ref="editParameterValueComponent"
            v-if="helper.isTramosDistintos() && helper.mustShowDistanciaEntreSoportes()"
            :parameter="mainElement['distancia_soportes']"
            :value.sync="mainElement['distancia_soportes'].value"
            :placeholder_titel="
                mainElement['distancia_soportes'].attribute.name
            "
            :style_edit_param="
                'margin-top: ' +
                margin_dropdowns +
                'px ;margin-bottom: ' +
                margin_dropdowns +
                'px;'
            "
            :style_inside_dropdown="
                'padding:4px !important; width: ' + width_params
            "
            :labelOverInput="true"
            @update:value="refreshParameters"
            @beforeUpdate:value="beforeUpdate"
            @afterUpdate:value="afterUpdate"
            :prop_title_show="true"
        ></editParameterValueComponent>

        <template v-if="mainElement['opcion_compartimento']">
            <editParameterValueComponent
                :labelOverInput="false"
                :placeholder_titel="
                    mainElement['opcion_compartimento'].attribute.name
                "
                :parameter="mainElement['opcion_compartimento']"
                :value.sync="mainElement['opcion_compartimento'].value"
                labelOverInput="true"
                @update:value="refreshParameters"
                @beforeUpdate:value="beforeUpdate"
                @afterUpdate:value="afterUpdate"
                :style_inside_dropdown="
                    'padding:4px !important; width: ' + width_params
                "
                :style_inside_textbox="'width:' + width_params"
                :prop_title_show="true"
            ></editParameterValueComponent>
        </template>

        <!-- PARAMETROS IGUALES -->
        <h6 class="font-weight-bold pt-2 d-block text-left">{{ $t('s2_bandeja_escalera') }}</h6>

        <editParameterValueComponent
            :labelOverInput="false"
            :placeholder_titel="mainElement['dimensiones'].attribute.name"
            :parameter="mainElement['dimensiones']"
            :value.sync="mainElement['dimensiones'].value"
            @update:value="refreshParameters"
            @beforeUpdate:value="beforeUpdate"
            @afterUpdate:value="afterUpdate"
            :style_inside_dropdown="'padding:4px !important; width: ' + width_params"
            :style_inside_textbox="'width:' + width_params"
            :prop_title_show = "false"
        ></editParameterValueComponent>

        <editParameterValueComponent
            :labelOverInput="false"
            :placeholder_titel="mainElement['opcion_tapa'].attribute.name"
            :parameter="mainElement['opcion_tapa']"
            :value.sync="mainElement['opcion_tapa'].value"
            @update:value="refreshParameters"
            @beforeUpdate:value="beforeUpdate"
            @afterUpdate:value="afterUpdate"
            :style_inside_dropdown="'padding:4px !important; width: ' + width_params"
            :style_inside_textbox="'width:' + width_params"
            :prop_title_show = "false"
        ></editParameterValueComponent>

    </div>
</template>

<style lang="scss">
</style>

<script>
import jQuery from "jquery";
import Vue from "vue";
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import Helper from "../../services/b66b67helper.js";

export default {
    name: "mainElement67EditParametersComponent",
    data() {
        return {
            app: app,
            helper: new Helper(app)
        }
    },
    props: {
        mainElement: null,
        inverted: false
    },

    components: {
        editParameterValueComponent
    },
    computed: {
        width_params: function() {
            if (this.isMobile) {
                return "200px";
            } else {
                return "160px";
            }
        }
    },
    methods: {
        refreshParameters: async function() {
            await this.emitAsync("change");
        },
        beforeUpdate: async function(param, value, oldValue){
            try {
                await this.emitAsync("beforeUpdate", param, value, oldValue, this.mainElement);

            } catch (error) {

            }
        },
        afterUpdate: async function(param, value, oldValue){
            try {
                await this.emitAsync("afterUpdate", param, value, oldValue, this.mainElement);

            } catch (error) {

            }
        },

        async emitAsync(method, ...params){
            let listener = this.$listeners[method] || this.$attrs[method] || this[method]
            // console.warn(listener.fns)
            if(listener){
                if( typeof listener.fns[Symbol.iterator] === 'function'){
                    for (const fn of listener.fns) {
                        await fn(...params)
                    }
                }else{
                    await listener.fns(...params)
                }

            }
            return false
        },
    }
};
</script>